class Order {
    constructor (id, items, deliveryDetails, date, etd, instructions, status, discount, promoCode) {
        this.id = id;
        this.items = items;
        this.deliveryDetails = deliveryDetails;
        this.date = date;
        this.etd = etd;
        this.instructions = instructions;
        this.status = status;
        this.discount = discount;
        this.promoCode = promoCode;
    }
}

export default Order
